(function(){
  "use strict";
  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var tpl = document.getElementById("z87-panels");
  if(!tpl) return;
  function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }
  function Controller(section){
    this.s = section;
    this.grid = section.querySelector(".z87x-grid");
    if(this.grid.childElementCount) return;
    this.grid.appendChild(tpl.content.cloneNode(true));
    this.pDrop = this.grid.querySelector(".p-drop");
    this.pVel  = this.grid.querySelector(".p-velocity");
    this.pMass = this.grid.querySelector(".p-mass");
    this.counter = this.pVel.querySelector(".hv-counter");
    this.timers = []; this.raf = null; this.hasPlayed = false;
    var self = this;
    var replay = section.parentNode.querySelector(".z87x-replay") || section.querySelector(".z87x-replay");
    if (replay) replay.addEventListener("click", function(){ self.reset(); self.run(); });
    if (REDUCED){ this.staticState(); }
    else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting && !self.hasPlayed){ self.hasPlayed = true; self.run(); } });
      }, {threshold: 0, rootMargin: "0px 0px -80px 0px"});
      io.observe(section);
    }
  }
  Controller.prototype.clearTimers = function(){ this.timers.forEach(clearTimeout); this.timers = []; if (this.raf) cancelAnimationFrame(this.raf); };
  Controller.prototype.reset = function(){
    this.clearTimers();
    [this.pDrop, this.pVel, this.pMass].forEach(function(p){ p.classList.remove("play","fire","arm","played"); void p.offsetWidth; });
    this.counter.textContent = "0";
  };
  Controller.prototype.runCounter = function(done){
    var self = this, dur = 900, t0 = null;
    function step(ts){ if (!t0) t0 = ts; var t = Math.min((ts - t0) / dur, 1); self.counter.textContent = Math.round(easeOutCubic(t) * 102); if (t < 1){ self.raf = requestAnimationFrame(step); } else { done(); } }
    this.raf = requestAnimationFrame(step);
  };
  Controller.prototype.run = function(){
    if (REDUCED){ this.staticState(); return; }
    var self = this;
    var basic = this.s.getAttribute("data-rating") === "Z87";
    this.pDrop.classList.add("play");
    this.timers.push(setTimeout(function(){ self.pDrop.classList.add("played"); }, 1900));
    if (basic) return;
    this.timers.push(setTimeout(function(){ self.runCounter(function(){ self.pVel.classList.add("fire"); self.timers.push(setTimeout(function(){ self.pVel.classList.add("played"); }, 700)); }); }, 1500));
    this.timers.push(setTimeout(function(){ self.pMass.classList.add("play"); self.timers.push(setTimeout(function(){ self.pMass.classList.add("played"); }, 1700)); }, 3500));
  };
  Controller.prototype.staticState = function(){
    var basic = this.s.getAttribute("data-rating") === "Z87";
    this.counter.textContent = "102"; this.pDrop.classList.add("played");
    if (!basic){ this.pVel.classList.add("played"); this.pMass.classList.add("played"); }
  };
  document.querySelectorAll(".z87x").forEach(function(sec){ new Controller(sec); });
})();